import { QuartarDataType } from '../types/curriculum.types'

import { Quarter } from './Quarter'
interface Props {
  isQuarteredCurriculum: boolean
  quarterList: QuartarDataType[]
  selectedSubdivision: number
  isUSACurriculum?: boolean
}
export function Quarters({
  isQuarteredCurriculum,
  quarterList,
  selectedSubdivision,
  isUSACurriculum,
}: Props): React.ReactElement {
  const quarterSubjectsAccumulatedList = quarterList.map((_, idx) =>
    quarterList.slice(0, idx + 1).reduce((sum, q) => sum + q.subjects.length, 0),
  )

  return (
    <div className={`${isUSACurriculum ? '' : 'space-y-7 md:space-y-10'}`}>
      {quarterList.map((quarter, idx) => {
        return (
          <Quarter
            isHidden={isUSACurriculum ? selectedSubdivision !== idx : false}
            isLastQuarter={idx === quarterList.length - 1}
            isQuarteredCurriculum={isQuarteredCurriculum}
            isUSACurriculum={isUSACurriculum}
            key={quarter.subdivisionOrder}
            quarter={quarter}
            quarterIdx={idx}
            subjectCounter={quarterSubjectsAccumulatedList[idx - 1] ?? 0}
          />
        )
      })}
    </div>
  )
}
